/**
 * The purpose of the message module is to store and manage data
 * for visualizing snackbar-messages.
 *
 * MESSAGE-BODY:
 *  title: '',
 *  message: '',
 *  state: MessageState.NOTIFICATION,
 *  duration: 3000, // Time in ms
 */

export enum MessageState {
    NOTIFICATION = 'NOTIFICATION',
    ERROR = 'ERROR',
    WEBINAR = 'WEBINAR',
}

export interface Message {
    id?: string;
    title: string;
    message: string;
    state?: MessageState;
    icon?: string;

    duration?: number;
    persistent?: boolean;

    link?: {
        href: string;
        text: string;
    };
    playSound?: boolean;

    onClose?: () => void;
}

interface MessageModuleState {
    messages: Message[];
}

export interface MessageModule {
    getMessages: () => Message[];

    addNewMessage: (message: Message) => void;
    deleteMessage: (messageId: string) => void;
}

export default {
    state: {
        messages: [],
    } as MessageModuleState,
    getters: {
        getMessages: (state: MessageModuleState) => () => state.messages || [],
    },
    mutations: {
        addNewMessage(state: MessageModuleState, message: Message) {
            message = {
                ...message,
                id: Date.now()
                    .toString()
                    .concat(Math.random() * 10 + ''),
            };
            state.messages.push(message);
        },
        deleteMessage(state: MessageModuleState, messageId: string) {
            const index = state.messages.findIndex(m => m.id === messageId);
            if (index !== -1) state.messages.splice(index, 1);
        },
    },
};
